import React, { useRef, useState } from "react";
import CardBasic from "../CardBasic";
import ModalBasic from "../ModalBasic";
import ButtonRequire from "../Button/ButtonRequire";
import { toPng } from "html-to-image";
import axios from "axios";
import { HEADER } from "../../utils/Utils";
import FormData from "form-data";

function CardQR({
  data,
  enActionEdit,
  enActionDelete,
  editFunction,
  deleteFunction,
  isDisable,
}) {
  const [showModal, setShowModal] = useState(false);
  const elementRef = useRef(null);

  const htmlToImageConvert = () => {
    toPng(elementRef.current, { cacheBust: false })
      .then(async (dataUrl) => {
        const link = document.createElement("a");
        link.download = `${data.user_name}-${data.question_trigger?.replace(
          "#",
          "",
        )}*${data.akuisisi_id}.png`;

        let isSafari = false;
        const userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.includes("chrome")) {
          console.log("Google Chrome");
          // Your Google Chrome-specific logic here
        } else if (userAgent.includes("firefox")) {
          console.log("Mozilla Firefox");
          // Your Firefox-specific logic here
        } else if (userAgent.includes("safari")) {
          console.log("Apple Safari");
          isSafari = true;
          // Your Safari-specific logic here
        } else if (userAgent.includes("edge")) {
          console.log("Microsoft Edge");
          // Your Edge-specific logic here
        } else if (userAgent.includes("opera") || userAgent.includes("opr")) {
          console.log("Opera");
          // Your Opera-specific logic here
        } else {
          console.log("Unknown browser");
          // Handle other browsers here
        }
        if (!data.qr_asset) {
          // Split the base64 string to get the data part
          var dataPart = dataUrl.split(",")[1];

          // Decode the base64 data
          var decodedData = atob(dataPart);

          // Convert the decoded data to a Uint8Array
          var dataArray = new Uint8Array(decodedData.length);
          for (var i = 0; i < decodedData.length; i++) {
            dataArray[i] = decodedData.charCodeAt(i);
          }

          // Create a Blob from the Uint8Array
          var blob = new Blob([dataArray], { type: "image/png" });

          // Create a FormData object and append the Blob to it
          var formData = new FormData();
          formData.append(
            "file",
            blob,
            `${data.user_name}-${data.question_trigger?.replace("#", "")}*${
              data.akuisisi_id
            }.png`,
          );
          const HEADER_ASSETS = {
            // ...formData.getHeaders(),
            "X-Kartini-Signature": "a2FydGluaUAyMDIy",
            "Content-Type": "multipart/form-data",
          };
          let linkQR = await axios
            .post("https://asset.dashboard-kar-tini.com", formData, {
              headers: HEADER_ASSETS,
            })
            .then((res) => {
              // if success return link image\
              return `https://asset.dashboard-kar-tini.com/${res.data.data.id}`;
            })
            .catch((error) => {
              console.error("error", error);
              // return empty string
              return "";
            });

          await axios.put(
            `${process.env.REACT_APP_BASE_URL_API}/dynamic/link/${data.dynamic_link_id}`,
            { ...data, qr_asset: linkQR },
            { headers: HEADER },
          );
          data.qr_asset = linkQR;
        }
        // downloadImage(data.qr_asset, link.download);
        // Example usage
        // console.log("data");
        // var imageUrl =
        //   "https://generator.dashboard-kar-tini.com/qr/aHR0cHM6Ly93YS5tZS82MjgxMTEyNjAwNzAwP3RleHQ9JTIzS0FMQkVSRVRBSUxQQkYyMDI0VjEqNDgqNzU1NA==?base64=1";
        // var customFileName = "custom_filename.png";
        // downloadImage(data.qr_asset, customFileName);
        if (isSafari) {
          downloadImage(data.dynamic_link_qr, link.download);
        } else {
          link.href = dataUrl;
          link.click();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  function downloadImage(url, fileName) {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        // Create a link element
        var link = document.createElement("a");

        // Create a Blob URL from the fetched image blob
        var blobUrl = URL.createObjectURL(blob);

        // Set the link's href to the Blob URL
        link.href = blobUrl;

        // Set the download attribute to the desired file name
        link.download = fileName || "";

        // Append the link to the body
        document.body.appendChild(link);

        // Trigger a click event to start the download
        link.click();

        // Remove the link from the DOM
        document.body.removeChild(link);

        // Revoke the Blob URL to free up resources
        URL.revokeObjectURL(blobUrl);
      })
      .catch((error) => console.error("Error fetching image:", error));
  }

  return (
    <CardBasic
      key={data.akuisisi_id}
      i={data.akuisisi_id}
      title={data.user_name}
      isDisable={isDisable}
      enActionDelete={enActionDelete}
      enActionEdit={enActionEdit}
      editFunction={editFunction}
      deleteFunction={deleteFunction}
      data={data}
    >
      <ModalBasic
        name="add_outlet_modal"
        modalOpen={showModal}
        setModalOpen={setShowModal}
        title="QR Code"
        enClose={true}
      >
        <div className="px-2 pt-1 pb-2">
          <div className="space-y-3">
            <div ref={elementRef}>
              <img
                className="w-full object-cover object-center"
                src={data.dynamic_link_qr ?? ""}
                alt="qr"
                onClick={() => {
                  setShowModal(true);
                }}
              />
              <div className="flex w-full justify-around bg-slate-200 text-xs">
                <div>{data.user_name}</div>
                <div>|</div>
                <div>
                  {`${data.question_trigger}*${data.project_id}*${data.akuisisi_id}`}
                </div>
              </div>
              <div className="turncate bg-slate-100 text-center text-xs">
                {data.project_name}
              </div>
            </div>
            <ButtonRequire
              title="DOWNLOAD QR"
              functionOnClick={htmlToImageConvert}
              isDisabled={false}
            />
          </div>
        </div>
      </ModalBasic>
      <div className="px-5 py-4">
        <div className="space-y-3">
          <div className="flex items-center space-x-2">
            <div className="flex w-1/6 items-center text-sm">
              <div>
                <img
                  className="max-h-24 w-full object-cover object-center hover:opacity-60"
                  src={data.dynamic_link_qr ?? ""}
                  alt="qr"
                  onClick={() => {
                    setShowModal(true);
                  }}
                />
              </div>
            </div>
            <div className="flex w-5/6 flex-col space-y-2 text-sm">
              <div className="flex items-center text-sm">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="h-4 w-4 text-[#ED64BD]"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                  />
                </svg>
                <p className="ml-2 text-gray-500">{data.user_name}</p>
              </div>
              <div className="flex w-full items-center text-sm">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 text-[#ED64BD]"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
                  />
                </svg>
                <p className="ml-2 truncate text-gray-500">
                  {data.project_name}
                </p>
              </div>
              <div className="flex w-full items-center text-sm">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="h-4 w-4 text-[#ED64BD]"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5.25 8.25h15m-16.5 7.5h15m-1.8-13.5-3.9 19.5m-2.1-19.5-3.9 19.5"
                  />
                </svg>

                <p className="ml-2 text-gray-500">{`${data.question_trigger}*${data.project_id}*${data.akuisisi_id}`}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CardBasic>
  );
}

export default CardQR;
